import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { helpTopics } from "../../data/site";
import { SiteLink } from "../SiteLink";
export function AccidentHelp() {
  return <section aria-labelledby="help-title" className="border-y border-line bg-ivory" data-id="element-136" data-mp="299pgjt8wq5s6">
      <div className="page-container py-16 md:py-24" data-id="element-137" data-mp="297cup5013b9u">
        <h2 id="help-title" className="text-h2-m font-extrabold text-ink md:text-h2" data-id="element-138" data-mp="249tg23zf4whd">
          Find motorcycle accident help
        </h2>
        <p className="mt-5 max-w-measure text-slate" data-id="element-139" data-mp="2i816dt1y8zjk">
          A serious motorcycle crash can involve medical bills, no-fault benefits, wage loss, police reports, witnesses
          and pressure from insurance adjusters. Choose the issue that fits your situation, or call for a free review.
        </p>
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-140" data-mp="2n3glspflv3i3">
          {helpTopics.map(topic => <li key={topic.path} className="flex" data-id="element-141" data-mp="30yj0a0yiq16i">
              <SiteLink path={topic.path} className="group flex w-full flex-col rounded-lg border border-line bg-white p-6 hover:border-ink md:p-8" data-id="element-142" data-mp="2x0l76n1mmuxu">
                <h3 className="text-h3 font-bold text-ink group-hover:underline group-hover:underline-offset-4" data-id="element-143" data-mp="3368brox0vm50">
                  {topic.title}
                </h3>
                <p className="mt-2 text-slate" data-id="element-144" data-mp="3d338q3dndeh6">{topic.summary}</p>
                <span className="mt-auto inline-flex items-center gap-2 pt-5 text-label font-bold text-crimson" data-id="element-145" data-mp="3d19wm8k9m21s">
                  Read more
                  <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-146" data-mp="3m3j56svz3lcj" />
                </span>
              </SiteLink>
            </li>)}
        </ul>
      </div>
    </section>;
}